<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Orderpositions") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn class="ma-1" color="primary" @click="exportCSV">
          {{ $t("export csv") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-text-field
        v-model="filterDate"
        class="ml-4"
        :label="$t('exported_from')"
        type="date"
        clearable
        hide-details
        single-line
        style="max-width: 220px;"
      />
      <v-switch v-model="showAll" :label="$t('show all')"></v-switch>
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        show-select
        v-model="selected"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
      >
        <template v-slot:item.order.number="{ item }">
          <div v-if="item.order">
            <router-link
              :to="{ name: 'order.edit', params: { id: item.order.id } }"
              target="_blank"
              >{{ item.order.number }}</router-link
            >
          </div>
          <div v-else>
            ---
          </div>
        </template>

        <template v-slot:item.price="{ item }">
          {{
            Number(item.price).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }}
          €
        </template>
        <template v-slot:item.total_price="{ item }">
          {{
            Number(item.price * item.quantity).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }}
          €
        </template>
        <template v-slot:item.order.created_at="{ item }">
          <div v-if="item.order">
            {{
              item.order.created_at
                ? moment(item.order.created_at).format("DD.MM.YYYY")
                : "-"
            }}
          </div>
        </template>
        <template v-slot:item.exported_at="{ item }">
          {{
            item.exported_at
              ? moment(item.exported_at).format("DD.MM.YYYY")
              : "-"
          }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></advanced-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem, exportCSV } from "../shared/services";
import axios from "axios";
var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-orderPositions-list",
  data() {
    return {
      loading: true,
      options: {
        sortBy: ["exported_at"],
        sortDesc: [false],
        itemsPerPage: 100
      },
      total: 0,
      search: "",
      items: [],
      selected: [],
      filters: [],
      filterDate: null,
      showAll: false
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("Company"),
          align: "left",
          value: "order.customer.company.name",
          sortable: false
        },
        {
          text: this.$t("Order"),
          align: "left",
          value: "order.number"
        },
        {
          text: this.$t("project"),
          align: "left",
          value: "order.project"
        },
        {
          text: this.$t("order_date"),
          align: "left",
          value: "order.created_at"
        },
        {
          text: this.$t("description"),
          align: "left",
          value: "description"
        },
        {
          text: this.$t("label_type"),
          align: "left",
          value: "label_type.name"
        },
        {
          text: this.$t("price"),
          align: "right",
          value: "price"
        },
        {
          text: this.$t("quantity"),
          align: "right",
          value: "quantity"
        },
        {
          text: this.$t("total_price"),
          align: "right",
          value: "total_price"
        },
        {
          text: this.$t("exported"),
          align: "left",
          value: "exported_at"
        },
        { text: "", value: "action", sortable: false }
      ];
    },
    filterCols() {
      return [
        {
          title: this.$t("Company"),
          name: "order.customer.company.name",
          type: "text"
        },
        {
          title: this.$t("order"),
          name: "order.number",
          type: "text"
        },
        {
          title: this.$t("project"),
          name: "order.project",
          type: "text"
        },
        {
          title: this.$t("description"),
          name: "description",
          type: "text"
        }
      ];
    },
    computedFilters() {
      const filters = [...this.filters];
      if (this.filterDate) {
        // Positions with exported_at newer than the selected date (excludes null)
        filters.push("exported_at|>" + this.filterDate);
      } else if (!this.showAll) {
        filters.push("exported_at|null");
      }
      return filters;
    }
  },
  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      if (cancel != undefined) {
        cancel();
      }
      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          filters: this.computedFilters
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Orderpositions?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "orderPosition.edit", params: { id: url } });
    },
    async exportCSV() {
      let ids = this.selected.map(i => i.id);
      if (ids.length) {
        await exportCSV(ids);
        this.getData();
        this.selected = [];
      } else {
        this.$notification(this.$t("select_data"), { type: "error" });
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    },
    showAll: {
      handler() {
        this.getData();
      }
    },
    filterDate: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
